import React from 'react';
import './processing.css';
import { useTheme } from '../../components/context/ThemeContext';
import ContactRequest from '../../components/contact_request/ContactRequest';
import PlatformIcon from './components/PlatformIcon';
import ParallelProcessingIcon from './components/ParallelProcessingIcon';
import TransformationsIcon from './components/TransformationsIcon';
import GroundControlIcon from './components/GroundControlIcon';

const Processing = () => {
    const { theme } = useTheme();
    
    return (
        <div className={`processing-container ${theme}`}>
            <div className="processing-header">
                <h1>LiDAR Processing</h1>
                <p>Advanced LiDAR processing capabilities designed for massive datasets and unparalleled accuracy</p>
                <div className="top-cta">
                    <ContactRequest />
                </div>
            </div>
            
            <div className="processing-intro">
                <div className="intro-content">
                    <h2>The LiDAR Atlas Platform</h2>
                    <p>
                        LiDAR Consultants leverages the powerful LiDAR Atlas Platform—a cloud-based, 
                        scalable, and robust LiDAR processing engine capable of handling hundreds of thousands 
                        of square kilometers of LiDAR data in mere hours.
                    </p>
                    <p>
                        Our advanced processing infrastructure enables us to work with exceptionally large datasets, 
                        processing them massively in parallel for rapid turnaround times without compromising on quality.
                    </p>
                </div>
                <div className="intro-image">
                    <PlatformIcon />
                </div>
            </div>
            
            <div className="processing-section">
                <div className="processing-content">
                    <h2>Massive Parallel Processing</h2>
                    <p>
                        Our distributed processing infrastructure scales dynamically to meet project requirements,
                        allowing us to process terabytes of LiDAR data simultaneously. This parallel approach 
                        drastically reduces processing times while maintaining the highest quality standards.
                    </p>
                    <div className="processing-features">
                        <span className="feature-item">Cloud-Based Infrastructure</span>
                        <span className="feature-item">Auto-Scaling Capacity</span>
                        <span className="feature-item">High-Performance Computing</span>
                        <span className="feature-item">Terabyte-Scale Processing</span>
                    </div>
                </div>
                <div className="processing-image">
                    <ParallelProcessingIcon />
                </div>
            </div>
            
            <div className="processing-section reverse">
                <div className="processing-content">
                    <h2>Data Corrections & Transformations</h2>
                    <p>
                        We apply sophisticated correction algorithms to large LiDAR datasets, ensuring 
                        the highest level of accuracy. Our expertise enables us to perform complex datum 
                        transformations, adjusting datasets to match specific coordinate systems and projections.
                    </p>
                    <p>
                        With deep expertise in coordinate systems, projections, and geodetic frameworks, 
                        we ensure your data maintains the highest spatial integrity regardless of scope or scale.
                    </p>
                    <div className="processing-features">
                        <span className="feature-item">Datum Transformations</span>
                        <span className="feature-item">Projection Conversions</span>
                        <span className="feature-item">Epoch Shift Adjustments</span>
                        <span className="feature-item">Sensor Calibration</span>
                    </div>
                </div>
                <div className="processing-image">
                    <TransformationsIcon />
                </div>
            </div>
            
            <div className="processing-section">
                <div className="processing-content">
                    <h2>Ground Control Points & Accuracy</h2>
                    <p>
                        Achieving survey-grade accuracy requires high-quality Ground Control Points (GCPs). 
                        Whether integrating your existing GCPs or establishing new control points, we ensure 
                        that your LiDAR data meets the highest accuracy standards.
                    </p>
                    <p>
                        Our team includes licensed surveyors who oversee the establishment of GCPs and validate 
                        accuracy to ensure regulatory compliance for your project.
                    </p>
                    <div className="processing-features">
                        <span className="feature-item">Custom GCP Networks</span>
                        <span className="feature-item">Licensed Surveyors</span>
                        <span className="feature-item">Regulatory Compliance</span>
                        <span className="feature-item">Accuracy Verification</span>
                    </div>
                </div>
                <div className="processing-image">
                    <GroundControlIcon />
                </div>
            </div>
            
            {/*<div className="processing-metrics">*/}
            {/*    <div className="metric-item">*/}
            {/*        <div className="metric-number">100K+</div>*/}
            {/*        <div className="metric-description">Square km processed daily</div>*/}
            {/*    </div>*/}
            {/*    <div className="metric-item">*/}
            {/*        <div className="metric-number">99.9%</div>*/}
            {/*        <div className="metric-description">Accuracy achieved</div>*/}
            {/*    </div>*/}
            {/*    <div className="metric-item">*/}
            {/*        <div className="metric-number">24/7</div>*/}
            {/*        <div className="metric-description">Processing capability</div>*/}
            {/*    </div>*/}
            {/*    <div className="metric-item">*/}
            {/*        <div className="metric-number">50+</div>*/}
            {/*        <div className="metric-description">Projection systems supported</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            
            <div className="bottom-cta">
                <h2>Ready to Process Your LiDAR Data at Scale?</h2>
                <p>Our team of experts will help you transform raw LiDAR data into valuable, high-accuracy deliverables.</p>
                <ContactRequest />
            </div>
        </div>
    );
};

export default Processing;